import React, { Component } from 'react';
import './Banner.css';

export class Banner extends Component {

    render() {
        return (
            this.props.strings &&
            <div className="banner">
                <div className="banner-title">
                    {this.props.title}
                </div>
                <ul className="banner-list">
                    {this.props.strings?.map((str, index) => (
                        <li key={index}>{str}</li>
                    ))}
                </ul>
            </div>
        );
    }
}